import { render, staticRenderFns } from "./BackupDashboard.vue?vue&type=template&id=a325db60&"
import script from "./BackupDashboard.vue?vue&type=script&lang=js&"
export * from "./BackupDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports